import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Flex, Tooltip, type FlexProps } from '@mantine/core';
import styled from 'styled-components';

const DottedBadgeContainer = styled(Flex)<FlexProps & { $clickable: boolean }>`
	border: 1px dashed ${({ theme }) => theme.v3.colors.gray[6]};
	padding: 0.25rem;
	border-radius: 12.5rem;

	height: 1.5rem;
	min-height: 1.5rem;
	max-height: 1.5rem;

	width: 1.5rem;
	min-width: 1.5rem;
	max-width: 1.5rem;

	user-select: none;
	cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

interface Props {
	roleName?: string | null;
	onClick?: () => void;
}

export const UnassignedRoleBadge = ({ roleName, onClick }: Props) => {
	const tMipManage = useTranslationMipManage();
	const unassignedLabel = tMipManage('documents_page.columns.counterparty.unassigned');
	const label = roleName ? `${roleName} - ${unassignedLabel}` : unassignedLabel;
	const clickable = !!onClick;

	return (
		<Tooltip label={label} withArrow>
			<DottedBadgeContainer
				align="center"
				justify="center"
				$clickable={clickable}
				role={clickable ? 'button' : undefined}
				tabIndex={clickable ? 0 : undefined}
				onClick={
					clickable
						? (event) => {
								event.stopPropagation();
								onClick?.();
							}
						: undefined
				}
			>
				<Icon variant="plus" size="sm" color={defaultTheme.v3.colors.gray[6]} />
			</DottedBadgeContainer>
		</Tooltip>
	);
};
